<template>
  <canvas id="response-message-chart" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
export default {
  name: "ResponseMessageChart",
  props: {
    data: {
      type: Object,
      require: true,
    },
    yAxisTitle: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        parsing: {
          xAxisKey: "name",
          yAxisKey: "count",
        },
        layout: {
          padding: 0,
        },
        scales: {
          y: {
            ticks: {
              beginAtZero: true,
            },
            title: {
              display: true,
              align: "center",
              text: "จำนวนข้อความ(รายการ)",
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
          x: {
            ticks: {
              beginAtZero: true,
            },
            title: {
              display: true,
              align: "center",
              text: this.yAxisTitle,
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
          },
          tooltip: {
            bodyAlign: "center",
            yAlign: "bottom",
            titleColor: "#575757",
            backgroundColor: "#F1F1F1",
            titleMarginBottom: 0,
            padding: 12,
            callbacks: {
              title: function(context) {
                const contextElement = context[0];
                const chartDatas = contextElement.chart.data.datasets;
                const labelCollect = chartDatas.map((chartData) => {
                  const label = chartData.label;
                  const index = contextElement.dataIndex;
                  const data = chartData.data[index]
                  const dataFormated = data.countFormat
                  const unit = "รายการ";
                  return `${label} ${dataFormated} ${unit}`;
                });
                return labelCollect.join("\n");
              },
              label: function(context) {
                return;
              },
              afterLabel: function(context) {
                return;
              },
            },
          },
        },
      },
      gradient: null,
    };
  },
  mounted() {
    const ctx = document.getElementById("response-message-chart").getContext("2d");
    const gradientColor1 = ctx.createLinearGradient(0, 0, 0, 350);
    gradientColor1.addColorStop(0, "rgba(113, 96,196, 0.5)");
    gradientColor1.addColorStop(0.5, "rgba(113, 96, 196, 0.25)");
    gradientColor1.addColorStop(1, "rgba(113, 96, 196, 0)");

    const gradientColor2 = ctx.createLinearGradient(0, 0, 0, 350);
    gradientColor2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    gradientColor2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    gradientColor2.addColorStop(1, "rgba(0, 231, 255, 0)");
    new Chart(ctx, {
      type: "bar",
      data: {
        datasets: [
          {
            type: "bar",
            barPercentage: 0.4,
            label: "จำนวนข้อความ",
            order: 3,
            backgroundColor: "#E9D2F4",
            data: this.data.messageIn,
            borderRadius: {
              bottomLeft: 0,
              bottomRight: 0,
              topLeft: 10,
              topRight: 10,
            },
          },
          {
            type: "line",
            label: "แอดมินตอบกลับ",
            order: 2,
            backgroundColor: gradientColor2,
            borderColor: "#5CB7D9",
            pointBackgroundColor: this.data.adminResponse.length > 1 ? "transparent" : "#5CB7D9",
            pointBorderColor: this.data.adminResponse.length > 1 ? "transparent" : "#5CB7D9",
            data: this.data.adminResponse,
            tension: 0.4,
            fill: true,
          },
          {
            type: "line",
            label: "AI ตอบกลับ",
            order: 1,
            backgroundColor: gradientColor1,
            borderColor: "#7160C4",
            pointBackgroundColor: this.data.messageResponse.length > 1 ? "transparent" : "#7160C4",
            pointBorderColor: this.data.messageResponse.length > 1 ? "transparent" : "#7160C4",
            data: this.data.messageResponse,
            tension: 0.4,
            fill: true,
          },
        ],
      },
      options: this.options,
    });
  },
};
</script>

<style lang="scss" scoped></style>
